import { GET_TOUR_STEPS } from '_Resources/Header/Actions/getTourSteps';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TOUR_STEPS: {
      return {
        ...action.data,
      };
    }
    default: {
      return state;
    }
  }
};
